import { Card } from 'antd';
import React, { FC, useEffect, useState } from 'react';

interface CardContainerProps { loading?: boolean }
const CardContainer: FC<CardContainerProps> = ({ children, loading = false }) => {
  return <Card className="cardContainer" loading={loading}>{children}</Card>;
};
export default CardContainer;
